export default __webpack_public_path__ + "static/media/Vat.cd4db105.png";